/* LWA dark mode — quiet toggle, token flip, no-flash init.
   Artwork is never filtered or dimmed.

   AUTO MODE (default, no saved choice):
     1. Follows the device setting (prefers-color-scheme). On iPhone with
        iOS "Automatic" appearance this is already sunset/sunrise aware.
     2. If the device reports light but local time is night (19:00–07:00),
        the site still goes dark — night is dark, day is light.
     Auto re-evaluates live: on device appearance changes and once a minute
     for the clock, so the theme flips without a reload.

   MANUAL MODE: tapping the toggle stores an explicit choice and always wins.
   Mobile (≤900px): the text label becomes a compact icon in the header. */
(function () {
  var KEY = 'lwa-theme';
  var d = document, de = d.documentElement;
  var stored = null;
  try { stored = localStorage.getItem(KEY); } catch (e) {}

  var mq = (window.matchMedia) ? matchMedia('(prefers-color-scheme: dark)') : null;

  function nightNow() {
    var h = new Date().getHours();
    return h >= 19 || h < 7;
  }
  function computeAuto() {
    if (mq && mq.matches) return 'dark';
    return nightNow() ? 'dark' : 'light';
  }

  var mode = stored || computeAuto();

  function paint(n) {
    de.setAttribute('data-theme', n);
    var m = d.querySelector('meta[name="theme-color"]');
    if (m) m.setAttribute('content', n === 'dark' ? '#141412' : '#FBFAF7');
    var b = d.getElementById('lwaThemeToggle');
    if (b) {
      var lt = b.querySelector('.lt'), li = b.querySelector('.li');
      if (lt) lt.textContent = n === 'dark' ? 'Light' : 'Dark';
      if (li) li.textContent = n === 'dark' ? '☀' : '☾';
      b.setAttribute('aria-pressed', n === 'dark' ? 'true' : 'false');
    }
  }

  function autoApply() {
    if (stored) return;                 /* manual choice always wins */
    var n = computeAuto();
    if (n !== mode) { mode = n; paint(n); }
  }

  function apply(n) {                   /* manual: persist and paint */
    mode = n;
    stored = n;
    try { localStorage.setItem(KEY, n); } catch (e) {}
    paint(n);
  }

  paint(mode);

  /* live: device appearance flips (incl. iOS sunset/sunrise schedule) */
  if (mq && mq.addEventListener) mq.addEventListener('change', autoApply);
  /* live: the clock crossing 7am / 7pm */
  setInterval(autoApply, 60000);

  d.addEventListener('DOMContentLoaded', function () {
    var b = d.createElement('button');
    b.id = 'lwaThemeToggle';
    b.type = 'button';
    b.innerHTML = '<span class="lt">' + (mode === 'dark' ? 'Light' : 'Dark') + '</span><span class="li" aria-hidden="true">' + (mode === 'dark' ? '☀' : '☾') + '</span>';
    b.setAttribute('aria-label', 'Toggle dark mode');
    b.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
    b.style.cssText = 'background:none;border:none;cursor:pointer;font:800 .62rem/1 var(--sans,"Helvetica Neue",Arial,sans-serif);letter-spacing:.18em;text-transform:uppercase;color:var(--gray,#8C8C88);padding:.4rem .2rem;border-bottom:1px solid transparent;transition:color .2s,border-color .2s;';
    b.onmouseenter = function () { b.style.color = 'var(--gold,#B3893F)'; b.style.borderBottomColor = 'var(--gold-hi,#D6B26B)'; };
    b.onmouseleave = function () { b.style.color = 'var(--gray,#8C8C88)'; b.style.borderBottomColor = 'transparent'; };
    b.addEventListener('click', function () { apply(mode === 'dark' ? 'light' : 'dark'); });

    /* icon-only presentation at phone width */
    var st = d.createElement('style');
    st.textContent =
      '#lwaThemeToggle .li{display:none}' +
      '@media (max-width:900px){' +
      '#lwaThemeToggle{font-size:1rem!important;letter-spacing:0!important;padding:.3rem .45rem!important;border-bottom:none!important;line-height:1!important}' +
      '#lwaThemeToggle .lt{display:none}' +
      '#lwaThemeToggle .li{display:inline;font-size:1.05rem;transform:translateY(-1px)}' +
      '}';
    d.head.appendChild(st);

    var cart = d.querySelector('.cart-link, a[href*="cart"], #cartLink');
    if (cart && cart.parentNode) {
      cart.parentNode.insertBefore(b, cart);
    } else {
      b.style.position = 'fixed';
      b.style.right = '14px';
      b.style.bottom = '14px';
      b.style.zIndex = '9999';
      b.style.background = 'var(--paper,#FBFAF7)';
      b.style.border = '1px solid var(--hair,rgba(128,128,128,.35))';
      b.style.padding = '.55rem .8rem';
      d.body.appendChild(b);
    }
  });
})();
